import api from './index';

const apiPath = '/api/v1';

export default {
  createFilter(entityId, data) {
    return api({
      method: 'post',
      url: `${apiPath}/entities/${entityId}/default_filters`,
      data,
    });
  },

  removeFilter(entityId, defaultFilterId) {
    return api({
      method: 'delete',
      url: `${apiPath}/entities/${entityId}/default_filters/${defaultFilterId}`,
    });
  },

  addAsignation(entityId, defaultFilterId, data) {
    return api({
      method: 'post',
      url: `${apiPath}/entities/${entityId}/default_filters/${defaultFilterId}/asignation`,
      data,
    });
  },

  removeAsignation(entityId, defaultFilterId, data) {
    return api({
      method: 'delete',
      url: `${apiPath}/entities/${entityId}/default_filters/${defaultFilterId}/asignation`,
      data,
    });
  },
};
